/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureFlagsResponse
 */
export interface FeatureFlagsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof FeatureFlagsResponse
     */
    featureFlags: Array<string>;
}

/**
 * Check if a given object implements the FeatureFlagsResponse interface.
 */
export function instanceOfFeatureFlagsResponse(value: object): value is FeatureFlagsResponse {
    if (!('featureFlags' in value) || value['featureFlags'] === undefined) return false;
    return true;
}

export function FeatureFlagsResponseFromJSON(json: any): FeatureFlagsResponse {
    return FeatureFlagsResponseFromJSONTyped(json, false);
}

export function FeatureFlagsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureFlagsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'featureFlags': json['feature_flags'],
    };
}

  export function FeatureFlagsResponseToJSON(json: any): FeatureFlagsResponse {
      return FeatureFlagsResponseToJSONTyped(json, false);
  }

  export function FeatureFlagsResponseToJSONTyped(value?: FeatureFlagsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feature_flags': value['featureFlags'],
    };
}

